import React from "react";
import LayoutBase from "./LayoutBase";
import "../RegisterWolfScreen/Register.css";
import { HomeOutlined } from "@ant-design/icons";

import RegisterLegalEntityScreen from "./RegisterLegalEntityScreen";

type Props = {
  responeConfig: any;
};

const RegisterLegalEntiry: React.FC<Props> = ({ responeConfig }) => {
  const sideBar = (
    <div className="content-sidbar">
      <div className="content-sidbar-register" style={{ fontSize: "1.2rem" }}>
        <HomeOutlined rev={undefined} />
        <div>
          <div>ลงทะเบียนบริษัท</div>
          <div style={{ fontWeight: "lighter" }}>ประเภทนิติบุคคล</div>
        </div>
      </div>
    </div>
  );

  return (
    <LayoutBase responeConfig={responeConfig} sideMenu={sideBar}>
      <RegisterLegalEntityScreen />
    </LayoutBase>
  );
};

export default RegisterLegalEntiry;
